
<template>
  <v-card>
    <vue-cropper v-show="image" :aspect-ratio="1" ref="cropper" :minContainerHeight="300" :src="image" alt="Source Image"></vue-cropper>
    <v-divider></v-divider>
    <v-card-text class="pb-0">
      <v-form v-model="valid" ref="form">
        <v-row>
          <v-col cols="12" class="py-0" v-if="!zip">
            <v-file-input
              :rules="[v => (v || {}).size > 0 || 'Must have an Icon']"
              prepend-icon="mdi-image"
              placeholder="Pick an icon"
              accept="image/*"
              label="Icon"
              v-on:change="onImageSelected"
            ></v-file-input>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-text-field
              v-model="application"
              :rules="[v => !!v || 'Must have an Application Name']"
              prepend-icon="mdi-application"
              label="Application Name"
              type="text"
              v-on:input="updateFilename"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="py-0" v-if="source != 'universal'">
            <v-text-field
              v-model="applicationId"
              :rules="[v => !!v || 'Must have an Application ID']"
              prepend-icon="mdi-label"
              label="Application ID"
              type="text"
              v-on:input="updateFilename"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="py-0">
            <v-select
              v-model="source"
              prepend-icon="mdi-source-branch"
              label="Source"
              :items="items"
              v-on:input="updateFilename"
            ></v-select>
          </v-col>
          <v-col cols="6" class="py-0">
            <v-text-field
              v-model="version"
              prepend-icon="mdi-code-greater-than"
              label="Version"
              type="number"
              max="1000"
              min="1"></v-text-field>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-text-field
              :rules="[v => !v.includes('.c4z') || 'Must not contain .c4z', v => !v.includes('.c4i') || '.c4i not supported', v => !!v || 'Must have a filename']"
              v-model="filename"
              prepend-icon="mdi-file"
              label="Filename"
              type="text"
              suffix=".c4z"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="source == 'universal'">
          <v-expansion-panels accordion popout>
            <v-expansion-panel>
              <v-expansion-panel-header>Application IDs</v-expansion-panel-header>
                <v-expansion-panel-content>
                <v-col cols="12" v-for="brand in brands" :key="brand" class="py-0">
                  <v-text-field
                    v-model="applicationIds[brand]"
                    :label="brand"
                    type="text">
                  </v-text-field>
                </v-col>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="pt-0f">
      <v-btn label="Download" icon color="primary" v-on:click.native="download">
        <v-icon>mdi-cloud-download</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn label="Delete" icon color="red" v-on:click.native="$emit('delete')">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import JSZip from "jszip";
import Jimp from "jimp";
import moment from "moment";
import { vieraXml, vieraLua } from "../constants/viera.js";
import { webosXml, webosLua } from "../constants/webos.js";
import { universalXml, universalLua } from "../constants/universal_v2.js";
import brands from '../constants/brands.js';
import { saveAs } from 'file-saver';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

function escapeRegExp(str) {
  // eslint-disable-next-line
  return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}

function replaceAll(str, find, replace) {
  return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
}

export default {
  name: "MiniDriverCreator",
  components: {
    VueCropper
  },
  props: {
    initial: Object
  },
  data: () => ({
    brands: Object.values(brands),
    valid: true,
    filename: "",
    applicationId: "",
    source: "webos",
    application: "",
    applicationIds: {},
    replacesList: "",
    file: null,
    version: 1,
    zip: null,
    image: null,
    items: [
      { text: "WebOS", value: "webos" },
      { text: "Viera", value: "viera" },
      { text: "Universal", value: "universal" }
    ]
  }),
  created () {
    var self = this;
    if (this.initial && this.initial.zip) {
      this.zip = this.initial.zip
      this.filename = this.initial.filename.replace(".c4z", "")
      this.source = "universal"

      this.zip.file('www/icons/device/experience_1024.png').async("blob").then(function(data) {
        var reader = new FileReader();

        reader.onload = function() {
          self.image = reader.result
        };

        reader.readAsDataURL(data);
      })

      this.zip.file('driver.xml').async("string").then(function(xml) {
        let parser = new DOMParser();
        let xmlDoc = parser.parseFromString(xml,"text/xml");

        self.version = xmlDoc.getElementsByTagName("version")[0].childNodes[0].nodeValue;
        self.application = xmlDoc.getElementsByTagName("model")[0].childNodes[0].nodeValue;
        self.replacesList = xmlDoc.getElementsByTagName("replaces")[0].innerHTML;
      })

      this.zip.file('driver.lua').async("string").then(function(lua) {
        const result = Array.from(lua.matchAll(/(UM_[^ ]+)" ?: "(.+)"/g))

        result.forEach(function(m) {
          let brand = m[1]
          let id = m[2]

          self.applicationIds[brands[brand]] = id
        })
      })
    }
  },
  methods: {
    onImageSelected: function(image) {
      var self = this;
      self.file = image;

      if (!image) {
        self.image = {
          src: ""
        };
        return;
      }

      var reader = new FileReader();

      reader.onload = (event) => {
        self.image = {
          title: image.name,
          type: image.type,
          src: event.target.result
        };

        this.$refs.cropper.replace(event.target.result);
      };

      reader.readAsDataURL(image);
    },
    updateFilename: function() {
      if (this.source != "universal") {
        this.filename =
          this.application.toLowerCase().replace(" ", "_") +
          "_" +
          this.source.toLowerCase() +
          "_mini_driver";
      } else {
        this.filename =
          "um_" + this.application.toLowerCase().replace(" ", "_");
      }
    },
    download: function() {
      if (!this.$refs.form.validate()) {
        return;
      }

      var self = this;

      // Start the zip file
      var zip = new JSZip();

      // Create folder locations
      var www = zip.folder("www");
      var icons = www.folder("icons");
      var device = icons.folder("device");

      let xml = this.source == "viera" ? vieraXml : webosXml;
      let lua = this.source == "viera" ? vieraLua : webosLua;

      lua = this.source == "universal" ? universalLua: lua;
      xml = this.source == "universal" ? universalXml: xml;

      // Replace xml template place holders with values
      var convertedXml = replaceAll(xml, "[[APP_NAME]]", this.application);
      convertedXml = replaceAll(convertedXml, "[[VERSION]]", this.version || 1);
      convertedXml = replaceAll(
        convertedXml,
        "[[FILENAME]]",
        this.filename.replace(".c4z", "")
      );
      convertedXml = replaceAll(
        convertedXml,
        "[[DATE_TIME]]",
        moment().format("MM/DD/YYYY h:mm:ss a")
      );

      convertedXml = replaceAll(
        convertedXml,
        "[[LIST_REPLACES]]",
        this.replacesList
      )

      zip.file("driver.xml", convertedXml);
      
      // Replace lua template place holders with values
      var convertedLua = replaceAll(lua, "[[APP_ID]]", this.applicationId);
      convertedLua = replaceAll(convertedLua, "[[APP_NAME]]", this.application);
      convertedLua = replaceAll(convertedLua, "[[VERSION]]", this.version || 1);

      let sb = []
      let serviceIds = {};

      if (self.applicationIds) {
        let keys = Object.keys(brands)

        keys.forEach(function(k) {
          let item = self.applicationIds[brands[k]]

          if (item) {
            serviceIds[k] = item
            sb.push(`    ${k} = '${item}'`)
          }
        })
      }

      let data = {
        serviceIds: serviceIds,
        appName: this.application
      }

      //convertedLua = replaceAll(convertedLua, "[[ID_LIST]]", "{\r\n" + sb.join(',\r\n') + "\r\n}")
      convertedLua = replaceAll(convertedLua, "ENCODED_APP_DATA", JSON.stringify(data, null, 2))

      zip.file("driver.lua", convertedLua);

      let canvas = this.$refs.cropper.getCroppedCanvas();
      let imgData = canvas ? canvas.toDataURL() : self.image;

      Jimp.read(imgData).then(function(img) {
        // Resize all of the images
        var finished = Promise.all([
          img.getBufferAsync(Jimp.MIME_PNG),
          img.resize(512, 512).getBufferAsync(Jimp.MIME_PNG),
          img.resize(300, 300).getBufferAsync(Jimp.MIME_PNG),
          img.resize(90, 90).getBufferAsync(Jimp.MIME_PNG),
          img.resize(70, 70).getBufferAsync(Jimp.MIME_PNG),
          img.resize(32, 32).getBufferAsync(Jimp.MIME_PNG),
          img.resize(16, 16).getBufferAsync(Jimp.MIME_PNG)
        ]);

        // Save all of the images into the zip file
        finished.then(function(buffers) {
          icons.file("device_sm.png", buffers[6]);
          icons.file("device_lg.png", buffers[5]);
          device.file("experience_70.png", buffers[4]);
          device.file("experience_90.png", buffers[3]);
          device.file("experience_300.png", buffers[2]);
          device.file("experience_512.png", buffers[1]);
          device.file("experience_1024.png", buffers[0]);

          var p = zip.generateAsync({ type: "blob" });

          p.then(function(content) {
            saveAs(content, self.filename + ".c4z");
          });
        });
      });
    }
  }
};
</script>